/**
 * Animation actions that were user-facing in the Template Builder when ADSCM-1512 started.
 * A later animation feature adds its own row and WebMCP coverage in its own ticket.
 */
export const ANIMATION_CAPABILITY_FREEZE_DATE = '2026-10-09';

export type AnimationCapabilityRow = {
  action: string;
  editorEntryPoint: string;
  webmcp:
    | { tool: 'template_builder_apply'; operation: string }
    | { tool: 'template_builder_read'; readType: string; mode?: string }
    | { tool: 'template_builder_get_capability_info'; topic: string }
    | { tool: null; reason: string };
};

export const ANIMATION_CAPABILITY_MATRIX: readonly AnimationCapabilityRow[] = [
  {
    action: 'List entrance and exit presets',
    editorEntryPoint: 'Animate tab, Add New Animation menu',
    webmcp: { tool: 'template_builder_get_capability_info', topic: 'animation' },
  },
  {
    action: 'Apply a preset to an element',
    editorEntryPoint: 'Animate tab, Add New Animation menu',
    webmcp: { tool: 'template_builder_apply', operation: 'apply_animation_effect' },
  },
  {
    action: 'Edit duration, start, easing, or slide distance',
    editorEntryPoint: 'Animate tab, applied effect panel',
    webmcp: { tool: 'template_builder_apply', operation: 'update_animation_effect' },
  },
  {
    action: 'Change the preset of an applied effect within its role',
    editorEntryPoint: 'Animate tab, applied effect Type select',
    webmcp: { tool: 'template_builder_apply', operation: 'update_animation_effect' },
  },
  {
    action: 'Remove an applied effect',
    editorEntryPoint: 'Animate tab, applied effect Remove button',
    webmcp: { tool: 'template_builder_apply', operation: 'remove_animation_effect' },
  },
  {
    action: 'Inspect applied effects and generated tracks',
    editorEntryPoint: 'Animate tab, applied effect list',
    webmcp: { tool: 'template_builder_read', readType: 'animation' },
  },
  {
    action: 'Replay the animation in the preview',
    editorEntryPoint: 'Preview footer, Replay button',
    webmcp: { tool: 'template_builder_read', readType: 'preview', mode: 'video' },
  },
  {
    action: 'Edit timeline duration, FPS, or loop',
    editorEntryPoint: 'Not user-facing at kickoff',
    webmcp: { tool: null, reason: 'Timeline metadata is read-only.' },
  },
  {
    action: 'Edit raw tracks or keyframes',
    editorEntryPoint: 'Not user-facing at kickoff',
    webmcp: { tool: null, reason: 'Generated tracks are read-only.' },
  },
];
